import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Modal, InputGroup } from "react-bootstrap";
import AddEditAchievementModal from "./addEditAchievement";
import {
  deleteAchievementById,
  paginatedAchievementList,
  restoreAchievemnet,
  searchAchievements,
  toggleAchievementStatus,
} from "../../services/axios/apiManager";
import { toast } from "sonner";
import { handleErrors } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";
import BSPagination from "../../Components/pagination";
import LoadingSpinner from "../../Components/spinner";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

const AchievementsList = ({
  achievements,
  setachievements,
  pagination,
  setPagination,
  granted,
}) => {
  const navigate = useNavigate();
  const [selectedAchievement, setSelectedAchievement] = useState({});
  const [openAddEditModal, setOpenAddEditModal] = useState(false);
  const [modalOptions, setModalOptions] = useState({}); //
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [query, setQuery] = useState("");
  const [filters, setFilters] = useState(3);
  const [filtering, setFiltering] = useState(false);
  // const []

  const tableRef = useRef(null);

  const columns = [
    { data: "name", title: "Name" },
    { data: "description", title: "Description" },
    { data: "requirements", title: "Requirements" },
  ];

  // // // Fetch Achievements again with pagination
  const fetchAchievements = async (pagination, str = "") => {
    setFiltering(true);
    const res = await paginatedAchievementList(
      pagination.currentPage,
      pagination.pageSize,
      str
    );
    if (res?.data?.success && res?.data?.data) {
      setachievements(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      handleErrors(res, navigate);
    }
    setFiltering(false);
  };

  // // // Filters Logic
  // // // status = 0-Inactive, 1-Active, 2-deleted, 3 default
  const fetchFilteredAchievements = async (e) => {
    setQuery("");
    setFilters(e.target.value);
    const string = `status=${e.target.value}`;
    await fetchAchievements(pagination, string);
  };

  // // // Change the page
  const handlePageChange = async (page) => {
    const temp = { ...pagination };
    setPagination((prev) => ({ ...prev, currentPage: page }));
    temp.currentPage = page;
    const str = `status=${filters}`;
    fetchAchievements(temp, str);
  };

  const handleSearch = async (e) => {
    setFiltering(true);
    const string = e.target.value;
    setQuery(string);
    if (string.length > 0) {
      const res = await searchAchievements(string);
      if (res?.data?.data) {
        setachievements(res.data.data);
        if (res?.data?.pagination) {
          setPagination(res.data.pagination);
        }
      } else {
        handleErrors(res, navigate);
      }
    } else {
      const str = `status=${filters}`;
      await fetchAchievements(pagination, str);
    }
    setFiltering(false);
  };

  // // // Open Achievement Add Edit modal
  const handleAddEditAchievement = (ach) => {
    setSelectedAchievement(ach);
    setOpenAddEditModal(true);
  };

  // // // Change status logic
  const changeStatus = async (data) => {
    const res = await toggleAchievementStatus(data);
    if (res?.data?.success === true) {
      const str = `status=${filters}`;
      await fetchAchievements(pagination, str);
      toast.info("Achievement status has been updated!", {
        duration: 2000,
      });
      setModalOptions({});
      setShowOptionsModal(false);
    } else {
      handleErrors(res, navigate);
    }
  };

  // // // Delete Achievement logic
  const deleteAchievement = async (data) => {
    if (data.id) {
      const res = await deleteAchievementById(data.id);
      if (res?.data?.success) {
        const str = `status=${filters}`;
        await fetchAchievements(pagination, str);
        toast.info("Achievement record has been deleted!", {
          duration: 2000,
        });
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        handleErrors(res, navigate);
      }
    }
  };

  const restoreAchievementById = async (data) => {
    if (data.id) {
      const res = await restoreAchievemnet(data.id);
      if (res?.data?.success) {
        const str = `status=${filters}`;
        await fetchAchievements(pagination, str);
        toast.info("Achievement record has been restored!", {
          duration: 2000,
        });
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        handleErrors(res, navigate);
      }
    }
  };
  // // // Close Delete Modal
  const handleCloseOptionsModal = () => {
    setModalOptions({});
    setShowOptionsModal(false);
  };
  // // // Reset all filters to default
  const resetFilters = async () => {
    setFilters(3);
    setQuery("");
    await fetchAchievements(pagination, "status=3");
  };

  const promptAction = (header, body, method, data) => {
    setModalOptions({
      header,
      body,
      method,
      data,
      okay: header.includes("Delete") ? "Delete" : "Change",
    });
    setShowOptionsModal(true);
  };

  useEffect(() => {
    if (!tableRef.current) return;
    // Build DataTable rows
    const rows = achievements.map((ach) => {
      const base = columns.map((c) => ach[c.data]);
      const statusBtn = `<button class=\"btn btn-sm status-btn ${ach.status === 1 ? "text-success" : "text-danger"}\" data-id=\"${ach.id}\" title="change status">${ach.status === 1 ? "Active" : "Inactive"}<\/button>`;
      const actionBtns =
        ach.deletedAt === null
          ? `${granted?.some((p) => p.type === "update") ? `<button class=\"btn btn-outline-primary btn-sm edit-btn me-1\" data-id=\"${ach.id}\" title="edit"><i class=\"fas fa-edit\"></i></button>` : ""}` +
            `${granted?.some((p) => p.type === "delete") && ach?.status === 0 ? `<button class=\"btn btn-outline-danger btn-sm delete-btn\" data-id=\"${ach.id}\" title="delete"><i class=\"fas fa-trash\"></i></button>` : ""}`
          : `<button class=\"btn btn-outline-danger btn-sm restore-btn\" data-id=\"${ach.id}\" title="restore"><i class="fa-solid fa-rotate-right"></i></button>`;
      return [ach.id, ...base, statusBtn, actionBtns];
    });

    const config = {
      data: rows,
      columns: [
        { title: "ID", className: "text-start" },
        ...columns.map((c) => ({ title: c.title })),
        { title: "Status", orderable: false },
        { title: "Actions", orderable: false },
      ],
      destroy: true,
      responsive: true,
      pageLength: pagination.pageSize || 10,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().clear().rows.add(rows).draw();
    } else {
      $(tableRef.current).DataTable(config);
    }

    const $tbl = $(tableRef.current);
    $tbl.off("click", ".status-btn").on("click", ".status-btn", function () {
      const id = $(this).data("id");
      const ach = achievements.find((a) => a.id === id);
      if (ach?.deletedAt === null) {
        promptAction(
          "Change Status",
          `Toggle status of \"${ach.name}\"?`,
          changeStatus,
          { id, status: ach.status === 1 ? 0 : 1 }
        );
      } else {
        toast.info("Cannot change status of a deleted record!", {
          duration: 2000,
        });
      }
    });
    $tbl.off("click", ".view-btn").on("click", ".view-btn", function () {
      const id = $(this).data("id");
      const ach = achievements.find((a) => a.id === id);
      // optionally open a view modal if implemented
      setSelectedAchievement(ach);
      setShowOptionsModal(true);
    });
    $tbl.off("click", ".edit-btn").on("click", ".edit-btn", function () {
      const id = $(this).data("id");
      const ach = achievements.find((a) => a.id === id);
      setSelectedAchievement(ach);
      setOpenAddEditModal(true);
    });
    $tbl.off("click", ".delete-btn").on("click", ".delete-btn", function () {
      const id = $(this).data("id");
      const ach = achievements.find((a) => a.id === id);
      promptAction(
        "Delete Achievement",
        `Delete \"${ach.name}\"?`,
        deleteAchievement,
        { id }
      );
    });
    $tbl.off("click", ".restore-btn").on("click", ".restore-btn", function () {
      const id = $(this).data("id");
      const ach = achievements.find((a) => a.id === id);
      promptAction(
        "Restore Achievement",
        `Restore \"${ach.name}\"?`,
        restoreAchievementById,
        { id }
      );
    });

    return () => {
      $(tableRef.current).DataTable().destroy();
    };
  }, [achievements, pagination.pageSize, granted]);

  return (
    <div className="container py-4 text-light bg-dark p-3 rounded mb-4">
      <div className="row align-items-center mb-4">
        <div className="col-md-8 row">
          <div className="col-md-5">
            <Form.Control
              type="text"
              placeholder="Search Achievements..."
              value={query}
              onChange={(e) => handleSearch(e)}
              className="form-control bg-dark input-placeholder-light text-light border-light"
            />
          </div>
          <div className="col-md-5">
            <InputGroup className="mb-3">
              <Form.Select
                type="text"
                placeholder="Search FAQs by category..."
                value={filters}
                onChange={(e) => {
                  fetchFilteredAchievements(e);
                }}
                className="bg-dark text-light border-light input-placeholder-light"
              >
                <option value="3">Active & Inactive</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
                <option className="text-danger" value="2">
                  Deleted
                </option>
              </Form.Select>
            </InputGroup>
          </div>
          <div className="col-md-1">
            {filtering ? (
              <LoadingSpinner size={"md"} />
            ) : (
              <div className="row ">
                <Button
                  title="Reset Filters And Rrfresh Records"
                  className="btn btn-success"
                  onClick={() => {
                    resetFilters();
                  }}
                >
                  Reset
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className="col-md-4 text-end">
          {granted?.some((perm) => perm?.type === "create") && (
            <Button
              title="Add New Achievement"
              className="btn btn-success"
              onClick={() => {
                handleAddEditAchievement({});
              }}
            >
              <i className="bi bi-plus-circle"></i> Add New Achievement
            </Button>
          )}
        </div>
      </div>
      <div className="table-responsive">
        <table
          ref={tableRef}
          className="table table-striped table-dark"
          style={{ whiteSpace: "nowrap" }}
        />

        <div className="constainer-fluid">
          <div className="d-flex justify-content-end">
            <div className="mx-4 py-2">
              <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
            </div>
            <BSPagination
              currentPage={pagination?.currentPage}
              totalPages={pagination?.totalPages}
              onPageChange={handlePageChange}
              siblingCount={2}
              showFirstLast={true}
            />
          </div>
        </div>
      </div>
      <AddEditAchievementModal
        selectedAchievement={selectedAchievement}
        setSelectedAchievement={setSelectedAchievement}
        openAddEditModal={openAddEditModal}
        setOpenAddEditModal={setOpenAddEditModal}
        fetchAchievements={fetchAchievements}
        pagination={pagination}
      />
      <Modal
        show={showOptionsModal}
        onHide={handleCloseOptionsModal}
        centered
        className="text-light"
      >
        <Modal.Header closeButton className="bg-dark text-light border-0">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          {modalOptions.body}
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-0">
          <Button variant="secondary" onClick={handleCloseOptionsModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              modalOptions.method(modalOptions.data);
            }}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default AchievementsList;
